module.exports = __webpack_public_path__ + "img/mallikuva5.8d0c84d6.jpg";